import React from "react";
import { Button, Checkbox } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Modal } from "../../../controls/api";
import { activeGameId } from "../../../util/selectors";
import { useSelector } from "react-redux";
export default function DuplicatesDialog(props) {
    const { visible, onHide, onGetDuplicates, onRemoveMods, openDuplicateLocation, getModInfo, } = props;
    const [t] = useTranslation();
    const gameMode = useSelector(activeGameId);
    const [checked, setChecked] = React.useState([]);
    const [duplicates, setDuplicates] = React.useState({});
    const onSetChecked = React.useCallback((modId) => {
        const newState = checked.includes(modId)
            ? checked.filter((id) => id !== modId)
            : [].concat(checked, modId);
        setChecked(newState);
    }, [checked, setChecked]);
    const removeMods = React.useCallback(() => {
        const removeMap = checked.reduce((accum, iter) => {
            const modName = Object.keys(duplicates).find((id) => duplicates[id]?.includes(iter));
            if (modName === undefined) {
                return accum;
            }
            accum[iter] = duplicates[modName].find((id) => !checked.includes(id));
            return accum;
        }, {});
        onRemoveMods(removeMap);
        onHide();
    }, [checked, duplicates, onHide, onRemoveMods]);
    React.useEffect(() => {
        const duplicateData = onGetDuplicates();
        if (duplicateData !== undefined) {
            setDuplicates(duplicateData.duplicates);
            setChecked(duplicateData.preselected);
        }
        return () => {
            setDuplicates({});
            setChecked([]);
        };
    }, [gameMode]);
    const getInfo = React.useCallback((modId) => {
        return getModInfo(gameMode, modId);
    }, [getModInfo, gameMode]);
    const renderDuplicates = Object.keys(duplicates).map((name, idx) => {
        return (React.createElement(DuplicateSegment, { key: name + idx, checked: checked, entries: duplicates[name], modName: name, onSetCheckbox: onSetChecked, getModInfo: getInfo, openDuplicateLocation: openDuplicateLocation }));
    });
    const paragraph = t("Vortex may have pre-selected some of the mods for you " +
        "(if they were not referenced by any of your profiles) It's always a good " +
        "idea to double check the mod itself in the staging folder before removing " +
        "anything. The selected mods will be removed.");
    return (React.createElement(Modal, { show: visible, onHide: onHide },
        React.createElement(Modal.Header, null,
            React.createElement(Modal.Title, null, t("Choose Duplicates"))),
        React.createElement(Modal.Body, null,
            paragraph,
            renderDuplicates),
        React.createElement(Modal.Footer, null,
            React.createElement(Button, { onClick: onHide }, t("Cancel")),
            React.createElement(Button, { onClick: removeMods }, t("Remove Duplicates")))));
}
function DuplicateSegment(props) {
    const { modName, entries, checked, onSetCheckbox, openDuplicateLocation, getModInfo, } = props;
    const [modData, setModData] = React.useState({});
    const onChange = React.useCallback((evt) => {
        const modId = evt.target.value;
        onSetCheckbox(modId);
    }, [onSetCheckbox]);
    const onOpenFolder = React.useCallback((evt) => {
        const modId = evt.target.getAttribute("data-id");
        openDuplicateLocation(modId);
    }, [openDuplicateLocation]);
    React.useEffect(() => {
        const data = entries.reduce((accum, iter) => {
            accum[iter] = getModInfo(iter);
            return accum;
        }, {});
        setModData(data);
        return () => {
            setModData({});
        };
    }, [entries]);
    return (React.createElement("div", null,
        React.createElement("h5", null, modName),
        entries.map((modId, idx) => (React.createElement("div", { key: modId + idx },
            React.createElement("a", { "data-id": modId, onClick: onOpenFolder }, modId),
            React.createElement(Checkbox, { key: modId, checked: checked.includes(modId), value: modId, onChange: onChange }, modData[modId]))))));
}
